var PDF_STATUS = /* @__PURE__ */ ((PDF_STATUS2) => {
  PDF_STATUS2[PDF_STATUS2["NONE"] = 0] = "NONE";
  PDF_STATUS2[PDF_STATUS2["PENDING"] = 1] = "PENDING";
  PDF_STATUS2[PDF_STATUS2["LOADING_FILE"] = 2] = "LOADING_FILE";
  PDF_STATUS2[PDF_STATUS2["READY"] = 3] = "READY";
  PDF_STATUS2[PDF_STATUS2["ERROR"] = 4] = "ERROR";
  return PDF_STATUS2;
})(PDF_STATUS || {});
const PDF_OPTIONS_TO_EMBED_PROPERTIES = {
  FULL: "",
  MINI: "SIZED_CONTAINER"
};
const PDF_OPTIONS = {
  FULL: "FULL",
  MINI: "MINI",
  NONE: "NONE"
};
const PDF_CUSTOMIZATIONS = {
  PRINT: "disablePrint",
  DOWNLOAD: "disableDownload"
};
const RICOS_LOCALE_TO_ADOBE = {
  da: "da-DK",
  nl: "nl-NL",
  en: "en-US",
  fi: "fi-FI",
  fr: "fr-FR",
  de: "de-DE",
  it: "it-IT",
  ja: "ja-JP",
  no: "nb-NO",
  pt: "pt-BR",
  es: "es-ES",
  sv: "sv-SE",
  cs: "cs-CZ",
  ko: "ko-KR",
  pl: "pl-PL",
  ru: "ru-RU",
  tr: "tr-TR",
  zh: "zg-CN"
};
const ADOBE_EVENT_TO_PDF_STATUS = {
  APP_RENDERING_DONE: 3 /* READY */,
  PDF_VIEWER_OPEN: 2 /* LOADING_FILE */,
  APP_RENDERING_FAILED: 4 /* ERROR */
};

export { ADOBE_EVENT_TO_PDF_STATUS, PDF_CUSTOMIZATIONS, PDF_OPTIONS, PDF_OPTIONS_TO_EMBED_PROPERTIES, PDF_STATUS, RICOS_LOCALE_TO_ADOBE };
//# sourceMappingURL=pdfConsts.js.map
